import { render, staticRenderFns } from "./sleep-apnea-solutions.vue?vue&type=template&id=be891776&scoped=true&"
import script from "./sleep-apnea-solutions.vue?vue&type=script&lang=js&"
export * from "./sleep-apnea-solutions.vue?vue&type=script&lang=js&"
import style0 from "./sleep-apnea-solutions.vue?vue&type=style&index=0&id=be891776&lang=scss&scoped=true&"
import style1 from "./sleep-apnea-solutions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be891776",
  null
  
)

export default component.exports